



























































import { Component, Vue } from 'vue-property-decorator';
import { NewUsageSummary } from '@/api';

import StatTile from '@/components/common/StatTile.vue';
import DatePicker from '@/components/common/DatePicker.vue';

import dayjs from 'dayjs';

@Component({ components: { DatePicker, StatTile } })
export default class NewUsageSummaryDashboard extends Vue {
  newUsageSummary: NewUsageSummary | null = null;

  startDate: string | null = null;

  endDate: string | null = null;

  isLoading = false;

  async getUsageSummary() {
    if (!this.startDate || !this.endDate) {
      return;
    }

    this.isLoading = true;
    this.newUsageSummary = null;

    this.newUsageSummary = (
      await NewUsageSummary.where({
        start_date: this.startDate,
        end_date: this.endDate,
      }).first()
    ).data;

    this.isLoading = false;
  }

  mounted() {
    this.startDate = `${
      dayjs()
        .subtract(1, 'month')
        .startOf('day')
        .toISOString()
        .split('.')[0]
    }Z`;
    this.endDate = `${
      dayjs()
        .endOf('day')
        .toISOString()
        .split('.')[0]
    }Z`;
    this.getUsageSummary();
  }
}
